import {createContext, useState} from "react";

export const RegisterContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [register, setRegister] = useState(null);
    const [registers, setRegisters] = useState([]);
    const [registerDialog, setRegisterDialog] = useState(false);

    // Make the context object:
    const registerContext = {
        register,
        setRegister,
        registers,
        setRegisters,
        registerDialog,
        setRegisterDialog,
    };

    // pass the value in provider and return
    return <RegisterContext.Provider value={registerContext}>{children}</RegisterContext.Provider>;
}

export const {Consumer} = RegisterContext;
